import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, LikeOutlined, LoadingOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Button, Card, Comment, Form, Input, Modal, Spin, Tag, message } from "antd";
import { useState } from "react";
import { STATUS } from "./ReviewSelected";
import { authRequest } from "../../../common/request/authRequest";
import ReviewComment from "./ReviewComment";

export const ReviewAnswer = ({ keyId, getResponseIa, submitReply, replyForm, isLoadingIa, review, onFinish }) => {

    const [status, setStatus] = useState('');
 
    const deleteReply = async () => {

        const data = {
            reviewId: review.name
        };
        
        try {
            await authRequest(`${process.env.REACT_APP_API}/widgets/reviews/reply?key=${keyId}`, { method: 'DELETE', data })
            message.success('Se ha borrado la respuesta correctamente', 3);
            onFinish();
                
        } catch (error) {
            message.error('Error al eliminar la respuesta', 3);          
        }
    }    
    
    return (
        <Card style={{marginTop:'20px', marginLeft:'40px', background:'transparent', border:'0px'}} bodyStyle={{padding:'5px'}}>            
            {
                <div style={{ display: 'flex', justifyContent:'space-between' }}>

                    <div style={{ color: 'black', fontSize: '14px' }}>
                        <Avatar style={{ backgroundColor: '#87d068', marginRight: '10px' }} icon={<UserOutlined />} />
                        Propietario
                    </div>
                    {status === STATUS.EDITING &&
                        <Button
                            onClick={() => {
                                getResponseIa();
                            }}
                            style={{background:'ivory', color:'purple', borderRadius:'15px', fontWeight: '500' }}
                            size='small'>
                                {isLoadingIa ? 
                                    <Spin indicator={<LoadingOutlined spin />} /> 
                                    : 
                                    'Sugerencia con IA'
                                }
                        </Button>
                    }
                </div>
            }
              
            {status === STATUS.EDITING ? (
                    <Form layout='vertical'
                        form={replyForm}
                        onFinish={submitReply}
                        initialValues={{comment : review.reviewReplyComment?.originalText ? review.reviewReplyComment?.originalText : review.reviewReplyComment?.text}}
                    >                                                        
                        <Form.Item name='comment'>
                            <Input.TextArea
                                className='comment-answer'                            
                                style={{ width: '92%' }}
                                rows={6}
                                //onFocus={handleFocus}
                                //onBlur={handleBlur}
                            />
                        </Form.Item>
                        <div>
                            <a className='review-btn'
                                onClick={() => { replyForm.resetFields(); setStatus(''); }}
                            >
                                <CloseOutlined /> Cancelar
                            </a>
                            <a className='review-btn'
                                onClick={() => { replyForm.submit(); setStatus(''); }}
                            >
                                <CheckOutlined /> Aceptar
                            </a>
                        </div>                            
                    </Form>
                ) : (
                    !!review.reviewReplyComment && (
                        <div>
                            <ReviewComment comment={review.reviewReplyComment} scope={review.replyScope} reviewReplyUpdateTime={review.reviewReplyUpdateTime} isReply={true}/>                                 
                        </div>
                    )
                )
            }
            {
                status !== STATUS.EDITING && 
                <div style={{display:'flex', justifyContent:'left', marginTop:'5px'}}>
                    <a className='review-btn-grey'
                        onClick={() => setStatus('Editing')}>
                        <EditOutlined style={{ marginRight: '2x' }} /> Editar
                    </a>
                    <a className='review-btn-grey'
                        onClick={() => {
                            Modal.confirm({
                                title: '¿Confirmas que quieres borrar esta respuesta a la reseña?',
                                okText: 'Confirmar',
                                cancelText: 'Cancelar',
                                onOk: () => deleteReply(),
                                background: 'blue',
                            })
                        }}
                    >
                        <DeleteOutlined style={{ marginRight: '2px' }} /> Borrar
                    </a>
                </div>
            }
        </Card>
    )
}